// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-uploader>.ant-upload[data-v-80568996]{width:115px;height:115px}.avatar-uploader .userHead[data-v-80568996]{max-width:115px}.ant-upload-select-picture-card i[data-v-80568996]{font-size:32px;color:#999}.ant-upload-select-picture-card .ant-upload-text[data-v-80568996]{margin-top:8px;color:#666}", ""]);
// Exports
module.exports = exports;
